export const WALLETS_CONFIG = [
  {
    id: "btc",
    name: "Bitcoin Wallet",
    symbol: "BTC",
    network: "bitcoin",
    subNetworks: "BTC",
    icon: "https://cryptologos.cc/logos/bitcoin-btc-logo.svg",
    address: "bc1qp7whaf76ju8lrl9h258f3c9q8xy63ug62ecfny"
  },
  {
    id: "evm",
    name: "Ethereum Wallet",
    symbol: "ETH",
    network: "evm",
    subNetworks: "ETH • ERC-20",
    icon: "https://cryptologos.cc/logos/ethereum-eth-logo.svg",
    address: "0x2e37e96E99773bca048E5b255ae754ABEAa9b11F"
  },
  {
    id: "polygon",
    name: "Polygon Wallet",
    symbol: "POL",
    network: "polygon",
    subNetworks: "POL • ERC-20",
    icon: "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png",
    address: "0x2e37e96E99773bca048E5b255ae754ABEAa9b11F"
  },
  {
    id: "sol",
    name: "Solana Wallet",
    symbol: "SOL",
    network: "solana",
    subNetworks: "SOL",
    icon: "https://cryptologos.cc/logos/solana-sol-logo.svg",
    address: "9DGaMheq6TXNWXdGJugxSjznAD4C91ka8yAg5ay4wj83"
  },
  {
    id: "xrp",
    name: "XRP Wallet",
    symbol: "XRP",
    network: "xrp",
    subNetworks: "XRP",
    icon: "https://cryptologos.cc/logos/xrp-xrp-logo.svg",
    address: "raEbL5XfGQbUbpVJn2QEHf3G3Pu1sweYzZ"
  }
];
